import { useIntl } from "react-intl";

import { DeliveryStopPod } from "api/response";
import Dropdown from "components/atoms/Dropdown/Dropdown";
import { formatDeliveryStopLocationTitle } from "components/molecules/TopNav/common/NavIcons/MultistopProofActions/formatDeliveryStopOptionLabel";
import testIds from "constants/testIds";

/** Empty value keeps "Entire shipment" selectable through the string-based Dropdown options. */
const ENTIRE_SHIPMENT_VALUE = "";

export type TrackingStopAssociationFieldProps = Readonly<{
  stops: DeliveryStopPod[];
  value: number | null;
  onChange: (stopId: number | null) => void;
}>;

export default function TrackingStopAssociationField({ stops, value, onChange }: TrackingStopAssociationFieldProps) {
  const intl = useIntl();

  const options = [
    {
      label: intl.formatMessage({ id: "tracking.entireShipment", defaultMessage: "Entire shipment" }),
      value: ENTIRE_SHIPMENT_VALUE,
    },
    ...stops.map((stop) => ({
      label: formatDeliveryStopLocationTitle(stop),
      value: stop.stop_id,
    })),
  ];

  return (
    <div className="mt-3" data-testid={testIds.SHIPMENT_DASHBOARD_TRACKING_REFERENCE_STOP_SELECT}>
      <p className="mb-2 font-b3">{intl.formatMessage({ id: "tracking.deliveryStop", defaultMessage: "Delivery stop" })}</p>
      <Dropdown
        options={options}
        value={value ?? ENTIRE_SHIPMENT_VALUE}
        onChange={(option: any) => onChange(option?.value ? Number(option.value) : null)}
      />
    </div>
  );
}
